import React from 'react'
import PropTypes from 'prop-types'
import { TextContext } from 'hocs'
import * as Styled from './QualityIndicatorsOverlayContent.styles'
import { Indicator } from '../../../NursingIndicator/partials'
import { qualityIndicatorsLabels } from '../../qualityIndicatorsLabels'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import 'dayjs/locale/de'

const QualityIndicatorsOverlayContent = ({
  indicator = {},
  variant = 'circle',
}) => {
  const textContext = React.useContext(TextContext)
  const labels = useSelector((state) => state.detailData.labels)
  return (
    <Styled.QualityIndicatorsOverlayContent>
      <h3>{indicator.title}</h3>
      {indicator.type === 'multi' && (
        <p>
          <b>
            {indicator.interference}.{` `}
            <span
              dangerouslySetInnerHTML={{
                __html:
                  qualityIndicatorsLabels.interference[indicator.criteria][
                    indicator.interference
                  ],
              }}
            />
          </b>
        </p>
      )}
      {indicator.reportStatus === 2 || indicator.reportStatus === 3 ? (
        <p>
          {qualityIndicatorsLabels.reportStatusText[indicator.reportStatus]}
        </p>
      ) : (
        <>
          {indicator.criteria && (
            <p>
              {labels[`PE_PH_QUALITY_REPORT_INDICATORS_${ indicator.criteria }`]}
            </p>
          )}
          <p>
            <b>{textContext['nursingIndicator.overlay.rating.title']}</b>
          </p>
          {indicator.classification && indicator.classification === 7 && (
            <span>
              {
                textContext[
                  'nursingIndicator.overlay.indicator.prefix.singleCase'
                ]
              }
            </span>
          )}
          <div className='overlay-indicator'>
            <p>
              {indicator.classification < 6 &&
                indicator.classification > 0 &&
                textContext[
                  `nursingIndicator.overlay.indicator.prefix.${ variant }`
                ]}
              {indicator.classification &&
                textContext[
                  `nursingIndicator.indicator.${ variant }.${ indicator.classification }`
                ]}
              .
            </p>
            <div className='overlay-indicator-rating'>
              <Indicator variant={ variant } rating={ indicator.classification } />
            </div>
          </div>
          {indicator.classification &&
            indicator.classification < 6 &&
            indicator.classification > 0 && (
              <p>
                {qualityIndicatorsLabels.rate[indicator.criteria]
                  .replace(
                    '__RATE__',
                    Math.round((indicator.rate + Number.EPSILON) * 10) / 10
                  )
                  .replace(
                    '__REF_VALUE__',
                    Math.round((indicator.refValue + Number.EPSILON) * 10) / 10
                  )}
              </p>
            )}
          {indicator &&
            indicator.lastResults &&
            indicator.lastResults.length > 0 && (
              <>
                <p>
                  <b>
                    {textContext['nursingIndicator.overlay.pastResults.title']}
                  </b>
                </p>
                {indicator.lastResults &&
                  indicator.lastResults.map((indicator) => (
                    <React.Fragment key={ indicator.evaluationDate }>
                      <p className='overlay-rating-date'>
                        {dayjs
                          .unix(indicator.evaluationDate)
                          .locale('de')
                          .format('DD. MMMM YYYY')}
                      </p>
                      <div className='overlay-indicator'>
                        <p>
                          {indicator.classification > 0 &&
                            indicator.classification < 6 &&
                            textContext[
                              `nursingIndicator.overlay.indicator.prefix.${ variant }`
                            ]}
                          {
                            textContext[
                              `nursingIndicator.indicator.${ variant }.${ indicator.classification }`
                            ]
                          }
                          .
                        </p>
                        <div className='overlay-indicator-rating'>
                          <Indicator
                            variant={ variant }
                            rating={ indicator.classification }
                          />
                        </div>
                      </div>
                      {indicator.desc && <p>{result.desc}</p>}
                    </React.Fragment>
                  ))}
              </>
            )}
        </>
      )}
    </Styled.QualityIndicatorsOverlayContent>
  )
}

QualityIndicatorsOverlayContent.propTypes = {
  title: PropTypes.string,
  classification: PropTypes.number,
  criteria: PropTypes.number,
  interference: PropTypes.string,
  rate: PropTypes.number,
  refValue: PropTypes.number,
  lastResults: PropTypes.arrayOf(
    PropTypes.shape({
      classification: PropTypes.number,
      evaluationDate: PropTypes.number,
      reportStatus: PropTypes.number,
    })
  ),
  type: PropTypes.oneOf(['single', 'multi']),
  variant: PropTypes.oneOf(['circle', 'square']),
}

export default QualityIndicatorsOverlayContent
